module.exports = __webpack_public_path__ + "img/smplogo.1577302f.png";